module.exports = __webpack_public_path__ + "img/next_level_section-eb.f354e5df.png";